import { HttpInterceptor, HttpRequest, HttpHandler, HttpResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { Observable, of } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';

import { HttpConstants } from '../models/http.constants';
import { CacheService } from '../services/cache.service';

@Injectable()
export class CacheInterceptor implements HttpInterceptor {
  private cacheService = inject(CacheService);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<any> {
    if (req.method !== 'GET') {
      return next.handle(req);
    }

    if (!req.headers.has(HttpConstants.CacheIntercept)) {
      return next.handle(req);
    }

    const cacheKey = req.headers.get(HttpConstants.CacheIntercept);
    return this.cacheService.get(cacheKey).pipe(
      switchMap((cachedItem) => {
        if (cachedItem) {
          return of(new HttpResponse({ body: cachedItem, status: 200 }));
        } else {
          return next.handle(req).pipe(
            tap((res) => {
              if (res instanceof HttpResponse && res.ok) {
                this.cacheService.set(cacheKey, res.body);
              }
            })
          );
        }
      })
    );
  }
}
